import { useApolloClient } from '@apollo/client'
import { useMemo } from 'react'
import { MeQuery } from 'types/graphql'
import { getMeQuery } from 'modules/user/queries/me'

export type MaybeMe = MeQuery['me'] | null

export const useServerSideMe = (): { user?: MeQuery['me'] | null } => {
  const client = useApolloClient()

  /**
   * If the user has their auth ID token in a cookie, they might be logged in from the server-side,
   * which means the 'me' query will be cached. We can use this to determine if they're logged
   * in without waiting for firebase to load.
   */
  const user = useMemo(() => {
    try {
      const data = client.cache.readQuery<MeQuery>({ query: getMeQuery })
      return data?.me
    } catch {
      return null
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return { user }
}
